import useSWR from "swr";
import logger from "../../lib/logger";
import { getBoardWebhooks } from "../../utils/requests/webhookManagement";

interface Webhook {
  id?: string;
  event: string;
  board_id?: number;
  config?: any;
}

interface WebhooksResponse {
  installed: Webhook[];
  uninstalled: Webhook[];
}

const fetcher = async (boardId: number): Promise<WebhooksResponse> => {
  try {
    const data = await getBoardWebhooks(boardId);
    return { installed: data.installed, uninstalled: data.uninstalled };
  } catch (error: any) {
    logger.error("Error fetching webhooks", error);
    throw error;
  }
};

export const useWebhooks = (boardId: number) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR<WebhooksResponse>(
    boardId ? ["webhooks", boardId] : null,
    () => fetcher(boardId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return {
    webhooks: data?.installed || [],
    uninstalled: data?.uninstalled || [],
    isLoading,
    isValidating,
    error,
    mutate,
  };
};
